import React from 'react'
import injectSheet from 'react-jss'

const TopStep = (props) => {
  const {
    active,
    activated,
    classes,
    complete,
    history,
    index,
    noConnect,
    path,
    title,
    trail,
  } = props

  const handleClick = (e) => {
    if (activated && !active) {
      history.push(`${path}`)
      return true
    }
    e.preventDefault()
    return true
  }

  return (
    <li className={`${classes.listItem} ${activated && 'activated'} ${activated && complete && 'complete'} ${(active || trail) && 'active'} ${noConnect && 'noConnect'}`}>
      <div className={`${classes.progressBar}`} />
      <div
        className={`${classes.button}`}
        role="button"
        tabIndex={index}
        onClick={e => handleClick(e)}
        onKeyDown={() => false}
      >
        {index + 1}
        <h2 className={`${classes.title}`}>{title}</h2>
      </div>
    </li>
  )
}

const styles = theme => ({
  listItem: {
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    maxWidth: '150px',
    '&:first-of-type': {
      flexGrow: 0,
    },
    '&:first-of-type $progressBar': {
      display: 'none',
    },
    '&.activated $button': {
      color: theme.colors.main_3,
      borderColor: theme.colors.main_3,
    },
    '&.activated:not(.active) $button': {
      cursor: 'pointer',
    },
    '&.activated $title': {
      color: theme.colors.main_3,
    },
    '&.activated $progressBar': {
      backgroundColor: theme.colors.main_3,
    },
    '&.active $button': {
      color: theme.colors.main_1,
      borderColor: theme.colors.main_1,
    },
    '&.complete $button': {
      borderColor: theme.colors.main_1,
      backgroundColor: theme.colors.main_1,
      color: theme.colors.main_2,
    },
    '&.active $title': {
      color: theme.colors.main_1,
    },
    '&.complete $title': {
      color: theme.colors.main_1,
    },
    '&.complete $progressBar': {
      backgroundColor: theme.colors.main_1,
    },
    '&.noConnect $progressBar': {
      visibility: 'hidden',
    },
  },
  button: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    backgroundColor: theme.colors.main_2,
    color: theme.colors.secondary_3a,
    fontSize: '1em',
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: theme.colors.secondary_3a,
    borderRadius: '50%',
    height: '35px',
    width: '35px',
    [theme.media.medium]: {
      height: '50px',
      width: '50px',
      fontSize: '1.5em',
    },
    transition: [
      {
        property: 'color',
        duration: theme.speed.fast,
      },
      {
        property: 'border-color',
        duration: theme.speed.fast,
      },
      {
        property: 'background-color',
        duration: theme.speed.fast,
      },
    ],
  },
  title: {
    display: 'none',
    position: 'absolute',
    bottom: '-20px',
    left: '50%',
    transform: 'translate(-50%, 100%)',
    color: theme.colors.secondary_3a,
    fontSize: '14px',
    [theme.media.medium]: {
      display: 'block',
    },
    transition: [
      {
        property: 'color',
        duration: theme.speed.fast,
      },
    ],
  },
  progressBar: {
    backgroundColor: theme.colors.secondary_3a,
    height: '5px',
    width: 'calc(100% - 50px)',
    flexGrow: 2,
    transition: [
      {
        property: 'background-color',
        duration: theme.speed.fast,
      },
    ],
  },
})

export default injectSheet(styles)(TopStep)



// WEBPACK FOOTER //
// ./src/modules/core/components/topStep.jsx